import { SubscriptionName } from '@anm/api/modules/subscription';

import getOriginSubscriptionName from '../getOriginSubscriptionName';
import { singlePlanTopList } from '../isHighPlanSubscription';
import isTeamSubscription from '../isTeamSubscription';

const createPositionGetter = (list: string[]) => (name: SubscriptionName) =>
  list.indexOf(getOriginSubscriptionName(name));

const isHigherPlan = (currentPlan: SubscriptionName, targetPlan: SubscriptionName) => {
  if (isTeamSubscription(currentPlan) !== isTeamSubscription(targetPlan) || isTeamSubscription(targetPlan)) return true;

  const getPosition = createPositionGetter(singlePlanTopList);

  return getPosition(targetPlan) > getPosition(currentPlan);
};

export default isHigherPlan;
